import { render, staticRenderFns } from "./KimlikGecisSeridi.vue?vue&type=template&id=2e1bb189&scoped=true"
import script from "./KimlikGecisSeridi.vue?vue&type=script&lang=ts"
export * from "./KimlikGecisSeridi.vue?vue&type=script&lang=ts"
import style0 from "./KimlikGecisSeridi.vue?vue&type=style&index=0&id=2e1bb189&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e1bb189",
  null
  
)

export default component.exports